import {create} from 'zustand';

const useStore = create(set => ({
  title: '',
  modeIndex: 0, // Index into the available modes array
  tags: null,
  vertical: true,
  credits: null,
  pagination: false,
  arrow_prev: false,
  arrow_next: false,
  background: null,
  gradient: [],
  focus: true, // Add default value
  // tags data
  pinned: [],
  mastertags: {},
  masterTagBreadcrumb: ['home'],
  set: values => set(s => ({...s, ...values})),
}));

export default useStore;
